import React from "react";

const NotAccess = () => {
  return <div>Not Access</div>;
};

export default NotAccess;
